import { useEffect, useState } from 'react';
import { supabaseClient } from '../config/supabase';

export default function useTripPriceAccess(isUser) {
    const [allowed, setAllowed] = useState(!isUser);

    useEffect(() => {
        let active = true;
        if (!isUser) {
            setAllowed(true);
            return () => { active = false; };
        }

        setAllowed(false);
        supabaseClient.rpc('bl395a_trip_price_access')
            .then(({ data, error }) => {
                if (active) setAllowed(!error && data === true);
            })
            .catch((error) => {
                console.error('Trip-price access could not be checked:', error);
                if (active) setAllowed(false);
            });
        return () => { active = false; };
    }, [isUser]);

    return allowed;
}
